import { useEffect, useMemo, useState } from 'react'
import { FilterWrapper } from '../../shared/components/FilterWrapper/FilterWrapper'
import { Footer } from '../../shared/components/footer/footer'
import { Header } from '../../shared/components/header/header'
import ArticlesSection from './components/articles-section'
import GraphSection from './components/graph-section'
// import InteractiveMapSection from './components/interactive-map-section'
import IntroSection from './components/intro-section'
import MetodologySection from './components/metodology-section'

import MDatoEn from '../../assets/images/mapas/mapa_datos_en.svg'
import MDatoEs from '../../assets/images/mapas/mapa_datos_es.svg'
import MDatoPt from '../../assets/images/mapas/mapa_datos_pt.svg'

import './Home.scss'

export const Home = () => {
  const [isMobile, setIsMobile] = useState(
    window.matchMedia('(max-width: 768px)').matches
  )

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)')
    const handleChange = (e: any) => setIsMobile(e.matches)

    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  const getMDatoImage = useMemo(() => {
    const lang = new URLSearchParams(window.location.search).get('lang') || 'en'
    switch (lang) {
      case 'es':
        return MDatoEs
      case 'pt':
        return MDatoPt
      default:
        return MDatoEn
    }
  }, [])

  return (
    <div
      className="home"
      style={
        !isMobile
          ? { backgroundImage: `url(${getMDatoImage})` }
          : { backgroundImage: 'none' }
      }
    >
      <Header />
      <main>
        <IntroSection mDatoImage={getMDatoImage} />

        <FilterWrapper />

        <GraphSection />

        <ArticlesSection />

        <MetodologySection />
      </main>
      <Footer />
    </div>
  )
}
